/**
 * Maps role-management `appFormName` values to existing app routes.
 * Extend this map when new forms are added — do not rename existing paths.
 */
export const APP_FORM_ROUTE_MAP: Record<string, string> = {
  // Mess / Daysheet
  // DAYSHEET_DETAILS: '/messDetails',
  DAYSHEET_SUBMIT: '/messDetailsInventory',
  MEAL_ORDER_SUMMERY: '/mealOrderSummary',
  MEAL_ORDER_SUMMARY: '/mealOrderSummary',
  MESS_DETAILS: '/messDetails',
  MESS_INVENTORY: '/messInventory',
  MEAL_REQUEST: '/mealRequest',
  ADMIN_DASHBOARD_REPORTS: '/adminDashboardReports',
  ADMIN_DIVISION_REPORT: '/adminDivisionReport',
  ADMIN_MESS_INVENTORY: '/adminMessInventory',
  ADMIN_DAYSHEET_REPORT: '/adminDashboardReports',
  ADD_MENU_ITEM: '/addNewMenuItem',
  DAYSHEET_CLOSE: '/messDoDetails',
  MESS_DAYSHEET_FUSION_UPDATE: '/messClosedDetails',

  // Hygiene / Building
  BUILDING_IMAGE_DATA: '/building-image-data',
  HYGIENE_STAFF_ATTENDANCE: '/hygieneStaffAttendance',
  HYGIENE_DAY_WISE: '/hygiene-day-wise-report',
  HYGIENE_DAY_WISE_REPORT: '/hygiene-day-wise-report',
  HYGIENE_ACTIVITY: '/hygine-cleaning',
  TICKETING_REPORT: '/ticketingStaffAttendance',
  HYGIENE_LIVE_UPDATE: '/housekeeping-dashboard',
  HOUSEKEEPING_COMMAND_CENTRE: '/house-keeping-command-centre',
  HOUSEKEEPING_DASHBOARD: '/housekeeping-dashboard',
  HYGINE: '/hygine',
  BUILDING_DATA: '/BuildingData',

  // CCTV / Surveillance
  DASHBOARD: '/dashboard',
  DVR_NVR_STATUS: '/totaldvr',
  ADD_DVR: '/dvr/add-dvr',
  USER_DASHBOARD: '/userdashboard',
  GM_DASHBOARD: '/gmDashboard',

  // Grievance
  GRIEVANCE_LEVEL_1: '/studentGrievanceDashboard',
  GRIEVANCE_LEVEL_2: '/grievanceuser2',
  GRIEVANCE_ADMIN: '/grievanceAdmin',
  GRIEVANCE_SUPER_ADMIN: '/grievanceSuperadmin',
  GRIEVANCE_DASHBOARD: '/grievanceDashboard',
  GRIEVANCE_REPORT: '/grievanceReport',
  EMPLOYEE_GRIEVANCE: '/employeeGrievance/dashboard',

  // HR / HRMS
  HRMS_REPORT: '/HrmsReport',
  SUBJECT_DETAILS: '/hrmssubject',
  COST_CENTER_DETAILS: '/costcenter',
  DEPT_DESIG_DETAILS: '/deptdesign',
  EMPLOYEE_EXIT_DETAILS: '/employeeexit',
  MRF: '/hrDetails/mrfDashboard',
  BUDGET_FORM:'/hrDetails/budgetReport',
  MANPOWER_REQUISITION: '/hrDetails/manPowerRequisitionForm',

  // Academic / counselling
  ACADEMIC_COUNSELLING: '/AcademicCounsel',
  STUDENT_COUNSELLING: '/counselling',
  COUNSELLING_REPORT: '/studentcounsellingdashboard',
  STUDENT_COUNSELLING_DASHBOARD: '/studentcounsellingdashboard',
  STUDENT_COUNSELLING_EXCEL_REPORT: '/',
  COUNSELLING_EXCEL_REPORT: '/studentCounsellingExcelReport',
  COUNSELLING_DETAILS_EXCEL_REPORT: '/studentCounsellingdetailesReport',

  // Other modules
  PROGRESS_REPORT: '/progressReport',
  SECNARIO_BASED: '/ScenarioAssessment',
  ALL_INDIA_SCORE_REGISTRATION_2026: '/score/scoreRegistration',
  ALL_INDIA_SCORE_REPORT_2026_27: '/score/scoreReports',
  STUDENT_ATTENDANCE_V2: '/StudentAttendances',
  ATTENDANCE: '/Attendance',
  STUDENT_WELL_BEING: '/studentwellbeing',
  MERAKI_DASHBOARD: '/merakiDashboard',
  COURSE_MASTER: '/courseMaster',
  CAMPUS_TRACK: '/campus-Track',
  COURSE_TRACK: '/course-Track',
  ASSET_QR_ENTRY: '/assetQREntry',
  ASSET_QR_APPROVAL: '/assetQRApproval',
  VEHICLE_QR_ENTRY: '/vehicleQREntry',
  VEHICLE_QR_APPROVAL: '/vehicleQRApproval',
  ASSET_TRANSFER_ENTRY: '/assetTransferEntry',
  ASSET_TRANSFER_APPROVAL: '/assetTransferApprovaList',
  PRINT_BUILDING_ASSET_QR: '/printBuildingAssetQRDetail',
  PRINT_BULK_ASSET_QR: '/printBulkBuildingAssetQRDetail',
  PRINT_VEHICLE_QR: '/printBuildingVehicleQRDetail',
  PRINT_BULK_VEHICLE_QR: '/printBulkBuildingVehicleQRDetail',
  RECEIPT_CANCELLATION_APPROVAL_BY_DO: '/ReceiptCancellationApproval',
  IPE_MARKS_ENTRY: '/IpeMarks',
  NOTIFICATION: '/Notification',
  STUDENT_HT_VERIFICATION: '/studentHTNoVerification',
  MIGRATION: '/migration',
  LOG_TRACKING: '/log_tracking',
  SCORE_REGISTRATION: '/scoreRegistration',
  OUTING_DASHBOARD: '/outingDashboard',
  STUDENT_FEEDBACK: '/studentfeedback',
  SELF_ASSESSMENT: '/selfAssessment',
  SCENARIO_ASSESSMENT: '/ScenarioAssessment',
  STUDENT_WELLBEING: '/studentwellbeing',
  STUDENTWELLBEING_REPORT: '/studentwellbeingReport',
  STUDENT_ATTENDANCES: '/StudentAttendances',
  CAMPUS_GOOGLE_MAP: '/campusGooglemap',
  FACULTY_TRACKING: '/facultyTracking/dashboard',
  FACULTY_TRACKING_DASHBOARD:'/facultyTracking/dashboard',
  SECTION_WISE_FACULTY_TRACKING_REPORT:'/facultyTracking/sectionWiseReport',
  FACULTY_TRACKING_REPORT:'/facultyTrackingDashboard',
  JEE_MAIN_VERIFICATION: '/JEEMainVerification',
  MAIN_DASHBOARD: '/appScaits/mainDashboard',
  STUDENT_DASHBOARD: '/appScaits/mainDashboard',
  APP_SCAITS: '/appScaits/mainDashboard',
};

export function resolveAppFormRoute(appFormName: string | null | undefined): string | null {
  if (!appFormName) {
    return null;
  }
  const key = String(appFormName).trim();
  return APP_FORM_ROUTE_MAP[key] ?? APP_FORM_ROUTE_MAP[key.toUpperCase()] ?? null;
}
